module.exports = __webpack_public_path__ + "static/media/moon.bb7bb980.svg";